import React from "react";
import Grid from "@material-ui/core/Grid";
import Translator from "Languages/Utility/Translator";
import Input from "Components/Input/Input";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { useTranslation } from "react-i18next";

export default function AddNewLink({ controls, onChangeToggle, setValue, checkValid, formValid }) {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2}>
      {Object.keys(controls).map((key, index) => {
        return (
          <Grid item xs={12} key={key + index}>
            {controls[key].type === "toggle" && (
              <MuiRadioGroup
                name={key}
                label={<Translator id={key} />}
                value={controls[key].value}
                items={controls[key].arrayItems}
                onChange={onChangeToggle}
                translate={true}
                className="horizontalRadio mb-2"
              />
            )}
            {controls[key].type === "text" && (
              <Input
                setValue={setValue.bind(this)}
                value={controls[key].value}
                placeholder={t(key)}
                name={key}
                validation={controls[key].validation}
                label={<Translator id={key} />}
                type="text"
                checkValid={checkValid && !formValid[key]}
              />
            )}
          </Grid>
        );
      })}
    </Grid>
  );
}
